/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvitationTypeEnumDTO } from './InvitationTypeEnumDTO';
import {
    InvitationTypeEnumDTOFromJSON,
    InvitationTypeEnumDTOFromJSONTyped,
    InvitationTypeEnumDTOToJSON,
} from './InvitationTypeEnumDTO';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';
import type { NewOrganizationInvitationProjectEntryDTO } from './NewOrganizationInvitationProjectEntryDTO';
import {
    NewOrganizationInvitationProjectEntryDTOFromJSON,
    NewOrganizationInvitationProjectEntryDTOFromJSONTyped,
    NewOrganizationInvitationProjectEntryDTOToJSON,
} from './NewOrganizationInvitationProjectEntryDTO';

/**
 * 
 * @export
 * @interface NewOrganizationInvitationEntryDTO
 */
export interface NewOrganizationInvitationEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationInvitationEntryDTO
     */
    invitee: string;
    /**
     * 
     * @type {InvitationTypeEnumDTO}
     * @memberof NewOrganizationInvitationEntryDTO
     */
    invitationType: InvitationTypeEnumDTO;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof NewOrganizationInvitationEntryDTO
     */
    roleGrant: OrganizationRoleDTO;
    /**
     * 
     * @type {boolean}
     * @memberof NewOrganizationInvitationEntryDTO
     */
    addToAllProjects?: boolean;
    /**
     * 
     * @type {Array<NewOrganizationInvitationProjectEntryDTO>}
     * @memberof NewOrganizationInvitationEntryDTO
     */
    addToProjects?: Array<NewOrganizationInvitationProjectEntryDTO>;
}



/**
 * Check if a given object implements the NewOrganizationInvitationEntryDTO interface.
 */
export function instanceOfNewOrganizationInvitationEntryDTO(value: object): value is NewOrganizationInvitationEntryDTO {
    if (!('invitee' in value) || value['invitee'] === undefined) return false;
    if (!('invitationType' in value) || value['invitationType'] === undefined) return false;
    if (!('roleGrant' in value) || value['roleGrant'] === undefined) return false;
    return true;
}

export function NewOrganizationInvitationEntryDTOFromJSON(json: any): NewOrganizationInvitationEntryDTO {
    return NewOrganizationInvitationEntryDTOFromJSONTyped(json, false);
}

export function NewOrganizationInvitationEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewOrganizationInvitationEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'invitee': json['invitee'],
        'invitationType': InvitationTypeEnumDTOFromJSON(json['invitationType']),
        'roleGrant': OrganizationRoleDTOFromJSON(json['roleGrant']),
        'addToAllProjects': json['addToAllProjects'] == null ? undefined : json['addToAllProjects'],
        'addToProjects': json['addToProjects'] == null ? undefined : ((json['addToProjects'] as Array<any>).map(NewOrganizationInvitationProjectEntryDTOFromJSON)),
    };
}

export function NewOrganizationInvitationEntryDTOToJSON(value?: NewOrganizationInvitationEntryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invitee': value['invitee'],
        'invitationType': InvitationTypeEnumDTOToJSON(value['invitationType']),
        'roleGrant': OrganizationRoleDTOToJSON(value['roleGrant']),
        'addToAllProjects': value['addToAllProjects'],
        'addToProjects': value['addToProjects'] == null ? undefined : ((value['addToProjects'] as Array<any>).map(NewOrganizationInvitationProjectEntryDTOToJSON)),
    };
}

